<template>
    <div class="new-budget-side-form-container">
        <NewBudgetForm :is-side-form="true" />
    </div>
</template>

<script>
import NewBudgetForm from "@/new/components/Budget/NewBudgetForm.vue";

export default {
    name: "NewCategorySideform",

    components: {
        NewBudgetForm
    }
}
</script>

<style scoped lang="scss">
.new-budget-side-form-container {
    height: 100%;

    .new-budget-form {
        height: 100%;
    }
}
</style>